<template lang="html">
  <div class="result-list">
    <h3>
      <span>{{ isSubscribe? 1 : 2 }}</span>
      如果你想下载课程免流量学习，请下载APP！
    </h3>
    <div class="result-list-download" @click="download()" >
      <PickerButton width="282">立即下载</PickerButton>
      <PickerButton width="282">锁屏播放</PickerButton>
    </div>
    <h3 v-if="type === 'weixin'"><span>{{ isSubscribe? 2 : 3 }}</span>设置提醒时间</h3>
    <div class="result-list-main" v-if="type === 'weixin'">
      <div>
        <p>开启提醒</p>
        <input
          class="switch switch-anim"
          @change="changeSwitch"
          :value="switchType"
          type="checkbox"
          :checked="switchType"/>
      </div>
      <div>
        <p>当前提醒时间</p>
        <p class="result-list-main-time" @click="$router.push('custom-time')">{{hour | dateFilter}}:{{min | dateFilter}}&nbsp;></p>
      </div>
    </div>

      <Notice ref="notice">
        <div class="notice-main">
          <h1>温馨提示</h1>
          <p>亲爱的小主，您取消的不止是课程</p>
          <p>提醒，更是一种学习习惯哦！</p>
          <p> 提醒能让您坚持更长久！</p>
          <div class="notice-buttonGroup">
            <PickerButton width="220" type="gray" @click="closePush">取消推送</PickerButton>
            <PickerButton width="220" @click="$refs.notice.close();switchType=!switchType">保持学习</PickerButton>
          </div>
        </div>
      </Notice>
      <custom-time-bubble @closeBubble="closeBubble" v-if="isBubbleShow">
        07:00
      </custom-time-bubble>
    <!--</template>-->
  </div>
</template>

<script>
  import api from '@edu-fe/api'
  import os from '@edu-fe/os'
  import Notice from '../Notice'
  import PickerButton from '../UI/Button'
  import CustomTimeBubble from '../Custom/CustomTimeBubble'
  import { isxxx } from '@mixins'

  export default {
    name: 'ResultList',
    mixins: [isxxx],
    data () {
      return {
        switchType: 0,
        isBubbleShow: false,
        hour: 7,
        min: 0
      }
    },
    props: ['list', 'isSubscribe'],
    filters: {
      dateFilter (val) {
        return val < 10 ? '0'+ val : val
      }
    },
    async mounted () {
      const { data } = await api.custom.getInfo()
      this.switchType = data.switch
      this.hour = data.hour
      this.min = this.min
    },
    computed: {
      type () {
        return os.type
      }
    },
    methods: {
      async customTime () {
        // if (this.switchType) {
        //   this.$refs.notice.show()
        // } else {

        const { data } = await api.custom.push(420, 1)()
        if (data) {
          this.isBubbleShow = true
          this.switchType = 1
          this.hour = 7
          this.min = 0
        }
        // }
      },
      async closePush () {
        const { data } = await api.custom.switch()
        if (data) {
          this.switchType = 0
          this.$refs.notice.close()
        }
      },
      closeBubble () {
        this.isBubbleShow = false
      },
      changeSwitch () {
        this.switchType = !this.switchType
        if (!this.switchType) {
          this.$refs.notice.show()
          return
        }
        this.customTime()
      },
      download () {
        this.$emit('downloadApp', 'yyb1')
      }
    },
    components: {
      PickerButton,
      Notice,
      CustomTimeBubble
    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .result-list {
    /*border-bottom: 1px solid #E8E8E8;*/
    font-weight: bold;
    padding: 0 rem(30);
    margin-bottom: rem(60);
    position: relative;
    z-index: 100;
    &-desc {
      padding: rem(40);
      text-align: center;
      font-size: rem(32);
      color: #999999;
    }
    h3 {
      font-size: rem(28);
      font-weight: bolder;
      margin-bottom: rem(40);
      text-align: left;
      padding-top: rem(60);
      line-height: 1.4;
      span {
        display: inline-block;
        width: rem(36);
        background: url("../../assets/icons/icon-round.png") no-repeat;
        background-size: contain;
        color: white;
        text-align: center;
        margin-right: rem(30);
      }
    }
    &-download2 {
      width: 100vw;
      margin-top: rem(80);
      > img {
        width: 100%;
      }
    }
    &-download {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    &-main {
      > div {
        width: rem(624);
        margin-left: rem(66);
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: rem(28);
        margin-bottom: rem(23);
      }
      &-time {
        color: #F69000;
      }
    }
    &-item {
      /*border-bottom: 1px solid #E4E4E4;*/
      margin-bottom: -1px;
      font-size: use(30);
      white-space: nowrap;
      padding: rem(30) 0;
    }
    &-label {
      display: inline-block;
      color: #999999;
      margin-right: rem(15);
      vertical-align: middle;
      span {
        display: table-cell;
      }
      &-b {
        width: rem(26);
        height: rem(26);
        background-color: #F0F0F0;
        /*border: rem(4) double #fff;*/
      }
    }
    .active {
      background: {
        image: url('../../assets/icons/result-icon-right.png');
        repeat: no-repeat;
        size: contain;
      }
    }
    &-text {
      display: inline-block;
      &-btn {
        padding: rem(10) rem(18);
        border-radius: rem(10);
        color: #F69000;
        border: rem(3) solid #F69000;
      }
    }
    .notice-main {
      text-align: center;
      h1 {
        padding: rem(40) 0;
        font-size: rem(36);
        font-weight: bold;
      }
      p {
        font-size: rem(28);
        color: #333;
        line-height: 1.4;
      }
      .notice-buttonGroup {
        padding: rem(50) 0;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
      }
    }
  }
</style>
